import * as React from 'react';
import { Spinner } from 'components';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
require('./style.css');

interface IProps {
	show?: boolean;
	isWishlisted: boolean;
	wishlist: () => void;
	unwish: () => void;
	t?: (x: string) => string;
	menuItemClicked?: () => void;
	userContextMenuClickedOutsite?: (e: any) => void;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class WardrobeItemCardMenu extends React.Component<IProps, {}> {
	private node: HTMLElement;

	constructor(props) {
		super(props);

		this.handleWishlistClick = this.handleWishlistClick.bind(this);
		this.handleUnwishClick = this.handleUnwishClick.bind(this);
		this.handleClickOutside = this.handleClickOutside.bind(this);
		this.renderWishlistButton = this.renderWishlistButton.bind(this);
	}

	public componentDidMount() {
		document.addEventListener('click', this.handleClickOutside, true);
	}

	public componentWillUnmount() {
		document.removeEventListener('click', this.handleClickOutside, true);
	}

	private handleWishlistClick() {
		this.props.wishlist();
	}

	private handleUnwishClick() {
		this.props.unwish();
	}

	private handleClickOutside = (e) => {
		if (!this.node || !this.node.contains(e.target)) {
			if (this.props.show) {
				this.props.userContextMenuClickedOutsite(e);
			}
		}
	};

	private renderWishlistButton(isWishlisted?: boolean): JSX.Element {
		if (!this.props.wishlist) {
			return null;
		}

		const { t } = this.props;

		let wishlistBtnContent: JSX.Element = null;
		if (isWishlisted === undefined || isWishlisted === null) {
			wishlistBtnContent = (
				<div>
					<Spinner />
				</div>
			);
		} else if (!isWishlisted) {
			wishlistBtnContent = (
				<a
					onClick={() => {
						this.handleWishlistClick();
					}}
				>
					{t('BSPortal_Common_AddToWishlist')}
				</a>
			);
		} else {
			wishlistBtnContent = (
				<a
					onClick={() => {
						this.handleUnwishClick();
					}}
				>
					{t('BSPortal_Common_RemoveFromWishlist')}
				</a>
			);
		}
		return wishlistBtnContent;
	}

	public render() {
		const { isWishlisted, show } = this.props;

		return (
			<div
				ref={(node) => (this.node = node)}
				className="wardrobeItemCardMenu"
				style={{ display: show === true ? 'block' : 'none' }}
			>
				<div>{this.renderWishlistButton(isWishlisted)}</div>
			</div>
		);
	}
}
export { WardrobeItemCardMenu };
